var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "calendar-view-selector align-items-center" },
    [
      _c(
        "span",
        {
          staticClass: "calendar-view-selector__label color-black mr-3 font-17"
        },
        [_vm._v(" Mes/Año ")]
      ),
      _vm._l(_vm.periods, function(item, index) {
        return _c(
          "div",
          {
            key: "calendarViewSelector" + index,
            staticClass: "calendar-view-selector__option",
            class: [{ active: _vm.selected === item.id }],
            on: {
              click: function($event) {
                return _vm.onSelectHandler(item)
              }
            }
          },
          [
            _c("div", { staticClass: "calendar-view-selector__month" }, [
              _vm._v(_vm._s(item.monthShortName))
            ]),
            _c("div", { staticClass: "calendar-view-selector__year" }, [
              _vm._v(_vm._s(item.year))
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }